import { FC, ReactNode } from 'react';

import nl from 'date-fns/locale/nl';
import Picker, { registerLocale, ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker.scss';

registerLocale('nl', nl);

type TProps = ReactDatePickerProps & {
  trigger?: ReactNode;
};

const Datepicker: FC<TProps> = ({ trigger, ...props }) => (
  <Picker popperPlacement="bottom-start" {...props} customInput={trigger} locale="nl" />
);

export default Datepicker;
